
import React, { useState, useEffect } from 'react'
import {Col, Row, Form, DatePicker} from 'antd'
import {InputLabel, Title} from 'src/components/CommonStyles'
import {InputText} from "../reusables/TextInputs";
import styled from 'styled-components'
import Select from "../reusables/Select";
import Button from 'src/components/reusables/Button'
import {timeSelections} from "../../constants/datetime";
import {HHMMss, ndHHMMss} from 'src/helpers/datetime';
import APIService from 'src/services/APIService'
import  {useOrg} from 'src/hooks/useOrgContext'
import moment from 'moment'
   
    
const EditSchedNameForm = ({onCancel, onSave, schedule}: 
    {onCancel: () => void, onSave: () => void, schedule: any}) => {
    const [EditSchedName] = Form.useForm();
    const [validTimes, setValidTimes] = useState<any[]>([])

    const { put } = APIService()

    useEffect(() => {
        console.log('schedule', schedule)
    }, [])

    const updateSched = async (values: any) => {
        delete(schedule.dailys)
        delete(schedule.meta)
        put('/schedules/' + schedule.id, {
            ...schedule, name: values.name
        }).then(() => onSave())
    }
    
    return (
        <Form
            initialValues={schedule}
            form={EditSchedName}
            name="edit-schedule-form"
            style={{width: '100%'}}
            layout={'vertical'}
            onFinish={(values) => {
                console.log(values)
                updateSched(values)              
            }}
        >
            <Title>Edit Schedule Name</Title>
            <Row>
                <InputLabel>Schedule Name</InputLabel>
            </Row>
            <Form.Item
                name={'name'}
                style={{marginBottom: '10px', textAlign: 'left'}}
            >
                <InputText name={'name'} autoComplete='off' placeholder="Name"
                            style={{width: '100%'}}/>
            </Form.Item>
            <Form.Item
                style={{margin: '10px 0'}}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Button
                            size={'large'}
                            style={{width: '100%', margin: 0}}
                            onClick={() => onCancel()}
                        >Cancel</Button>
                    </Col>
                    <Col span={12}>
                        <Button
                            htmlType={'submit'}
                            type={'primary'}
                            size={'large'}
                            style={{width: '100%', margin: 0}}
                        >Save</Button>
                    </Col>
                </Row>
            </Form.Item>
        </Form>
    )
}


export default EditSchedNameForm

const StyledSelect = styled(Select)<{ isrounded?: boolean}>`
  &:not(.ant-select-customize-input) {
    .ant-select-selector {
      border-radius: ${({ isrounded }) => isrounded ? '30px' : '10px'};
      height: 50px;
    }
  }

  .ant-select-selection-item {
    text-align: left;
    align-self: center;
  }

  .ant-select-selection-placeholder {
    text-align: left;
    align-self: center;
  }
`